import {
  FaPlay,
  FaChartLine,
  FaTachometerAlt,
  FaMap,
  FaComment,
  FaClipboardList,
  FaColumns,
  FaBrain,
  FaTable,
  FaBoxOpen,
  FaListUl,
  FaBalanceScale,
  FaSlidersH,
  FaWaveSquare,
  FaProjectDiagram,
  FaRegStickyNote,
} from 'react-icons/fa';

/** Stable ids for dropdown / persistence (Firestore layout includes rideViewPanelStates.panelSlots). */
export const RIDE_PANEL_CONTENT_IDS = [
  'video',
  'charts',
  'stats',
  'map',
  'comments',
  'susp-summary',
  'susp-ai',
  'susp-statistics',
  'susp-packing',
  'susp-events',
  'susp-balance',
  'susp-advanced',
  'byb-stack-view',
  'byb-suspension',
  'byb-position-distrib',
  'byb-velocity-distrib',
  'byb-dynamic-balance',
  'byb-position-velocity',
  'byb-stroke-length',
  'byb-imu-distrib',
  'byb-imu-charts',
  'byb-brakes-speed',
  'byb-frequency',
  'byb-custom-xy',
  'byb-summary',
  'byb-comparison',
  'byb-auto-tuning',
  'byb-notes',
];

/** SuspensionAnalysisPanel tab id (embedded mode). */
export const SUSPENSION_TAB_BY_CONTENT_ID = {
  'susp-summary': 'summary',
  'susp-ai': 'ai-insight',
  'susp-statistics': 'statistics',
  'susp-packing': 'packing',
  'susp-events': 'events',
  'susp-balance': 'balance',
  'susp-advanced': 'advanced',
  'byb-suspension': 'suspension-traces',
  'byb-position-distrib': 'position-distrib',
  'byb-velocity-distrib': 'velocity-distrib',
  'byb-dynamic-balance': 'dynamic-balance',
  'byb-position-velocity': 'position-velocity',
  'byb-stroke-length': 'stroke-length',
  'byb-frequency': 'frequency',
  'byb-summary': 'summary',
  'byb-comparison': 'statistics',
  'byb-auto-tuning': 'auto-tuning',
  'byb-notes': 'ai-insight',
};

export const RIDE_PANEL_CATALOG = {
  video: {
    label: 'Video',
    icon: FaPlay,
    needsTelemetry: false,
    needsVideoSlot: false,
    needsGps: false,
    needsSuspensionData: false,
  },
  charts: {
    label: 'Charts',
    icon: FaChartLine,
    needsTelemetry: true,
    needsVideoSlot: false,
    needsGps: false,
    needsSuspensionData: false,
  },
  stats: {
    label: 'Stats',
    icon: FaTachometerAlt,
    needsTelemetry: true,
    needsVideoSlot: false,
    needsGps: false,
    needsSuspensionData: false,
  },
  map: {
    label: 'Map',
    icon: FaMap,
    needsTelemetry: true,
    needsVideoSlot: false,
    needsGps: true,
    needsSuspensionData: false,
  },
  comments: {
    label: 'Comments',
    icon: FaComment,
    needsTelemetry: false,
    needsVideoSlot: false,
    needsGps: false,
    needsSuspensionData: false,
  },
  'susp-summary': {
    label: 'Suspension · Summary',
    icon: FaClipboardList,
    needsTelemetry: true,
    needsVideoSlot: false,
    needsGps: false,
    needsSuspensionData: true,
  },
  'susp-ai': {
    label: 'Suspension · AI insight',
    icon: FaBrain,
    needsTelemetry: true,
    needsVideoSlot: false,
    needsGps: false,
    needsSuspensionData: true,
  },
  'susp-statistics': {
    label: 'Suspension · Statistics',
    icon: FaTable,
    needsTelemetry: true,
    needsVideoSlot: false,
    needsGps: false,
    needsSuspensionData: true,
  },
  'susp-packing': {
    label: 'Suspension · Packing',
    icon: FaBoxOpen,
    needsTelemetry: true,
    needsVideoSlot: false,
    needsGps: false,
    needsSuspensionData: true,
  },
  'susp-events': {
    label: 'Suspension · Events',
    icon: FaListUl,
    needsTelemetry: true,
    needsVideoSlot: false,
    needsGps: false,
    needsSuspensionData: true,
  },
  'susp-balance': {
    label: 'Suspension · Balance',
    icon: FaBalanceScale,
    needsTelemetry: true,
    needsVideoSlot: false,
    needsGps: false,
    needsSuspensionData: true,
  },
  'susp-advanced': {
    label: 'Suspension · Advanced',
    icon: FaSlidersH,
    needsTelemetry: true,
    needsVideoSlot: false,
    needsGps: false,
    needsSuspensionData: true,
  },
  'byb-stack-view': {
    label: 'Stack view',
    icon: FaChartLine,
    needsTelemetry: true,
    needsVideoSlot: false,
    needsGps: false,
    needsSuspensionData: false,
  },
  'byb-suspension': {
    label: 'Suspension traces',
    icon: FaWaveSquare,
    needsTelemetry: true,
    needsVideoSlot: false,
    needsGps: false,
    needsSuspensionData: true,
  },
  'byb-position-distrib': {
    label: 'Position distribution',
    icon: FaTable,
    needsTelemetry: true,
    needsVideoSlot: false,
    needsGps: false,
    needsSuspensionData: true,
  },
  'byb-velocity-distrib': {
    label: 'Velocity distribution',
    icon: FaTable,
    needsTelemetry: true,
    needsVideoSlot: false,
    needsGps: false,
    needsSuspensionData: true,
  },
  'byb-dynamic-balance': {
    label: 'Dynamic balance',
    icon: FaBalanceScale,
    needsTelemetry: true,
    needsVideoSlot: false,
    needsGps: false,
    needsSuspensionData: true,
  },
  'byb-position-velocity': {
    label: 'Position vs velocity',
    icon: FaProjectDiagram,
    needsTelemetry: true,
    needsVideoSlot: false,
    needsGps: false,
    needsSuspensionData: true,
  },
  'byb-stroke-length': {
    label: 'Stroke length',
    icon: FaBoxOpen,
    needsTelemetry: true,
    needsVideoSlot: false,
    needsGps: false,
    needsSuspensionData: true,
  },
  'byb-imu-distrib': {
    label: 'IMU distribution',
    icon: FaTable,
    needsTelemetry: true,
    needsVideoSlot: false,
    needsGps: false,
    needsSuspensionData: false,
  },
  'byb-imu-charts': {
    label: 'IMU charts',
    icon: FaWaveSquare,
    needsTelemetry: true,
    needsVideoSlot: false,
    needsGps: false,
    needsSuspensionData: false,
  },
  'byb-brakes-speed': {
    label: 'Brakes/speed',
    icon: FaTachometerAlt,
    needsTelemetry: true,
    needsVideoSlot: false,
    needsGps: false,
    needsSuspensionData: false,
  },
  'byb-frequency': {
    label: 'Frequency analysis',
    icon: FaWaveSquare,
    needsTelemetry: true,
    needsVideoSlot: false,
    needsGps: false,
    needsSuspensionData: true,
  },
  'byb-custom-xy': {
    label: 'Custom XY',
    icon: FaProjectDiagram,
    needsTelemetry: true,
    needsVideoSlot: false,
    needsGps: false,
    needsSuspensionData: false,
  },
  'byb-summary': {
    label: 'Summary',
    icon: FaClipboardList,
    needsTelemetry: true,
    needsVideoSlot: false,
    needsGps: false,
    needsSuspensionData: true,
  },
  'byb-comparison': {
    label: 'Comparison',
    icon: FaColumns,
    needsTelemetry: true,
    needsVideoSlot: false,
    needsGps: false,
    needsSuspensionData: true,
  },
  'byb-auto-tuning': {
    label: 'Auto tuning',
    icon: FaBrain,
    needsTelemetry: true,
    needsVideoSlot: false,
    needsGps: false,
    needsSuspensionData: true,
  },
  'byb-notes': {
    label: 'Notes',
    icon: FaRegStickyNote,
    needsTelemetry: false,
    needsVideoSlot: false,
    needsGps: false,
    needsSuspensionData: false,
  },
};

export function newPanelInstanceId() {
  return `slot-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

export function telemetryHasSuspensionSamples(telemetryData) {
  if (!Array.isArray(telemetryData) || telemetryData.length === 0) return false;
  return telemetryData.some((row) => rowHasSuspensionTelemetry(row));
}

/** @param {object} row */
function rowHasSuspensionTelemetry(row) {
  if (!row || typeof row !== 'object') return false;
  return (
    (typeof row.fork === 'number' && Number.isFinite(row.fork)) ||
    (typeof row.shock === 'number' && Number.isFinite(row.shock)) ||
    (typeof row.fork_normalized === 'number' && Number.isFinite(row.fork_normalized)) ||
    (typeof row.shock_normalized === 'number' && Number.isFinite(row.shock_normalized))
  );
}

/**
 * Whether a panel content type can show real content for this run.
 * @param {string} contentId
 * @param {{ hasTelemetry?: boolean, hasGps?: boolean, hasSuspensionSamples?: boolean, includeVideoPlaceholder?: boolean }} ctx
 */
export function isPanelContentRunnable(contentId, ctx) {
  const def = RIDE_PANEL_CATALOG[contentId];
  if (!def) return false;
  if (def.needsTelemetry && !ctx.hasTelemetry) return !!ctx.includeVideoPlaceholder;
  if (def.needsGps && !ctx.hasGps) return false;
  if (def.needsSuspensionData && !ctx.hasSuspensionSamples) return false;
  return true;
}

function legacyBool(obj, key, defaultTrue = true) {
  if (obj == null || typeof obj !== 'object') return defaultTrue;
  if (Object.prototype.hasOwnProperty.call(obj, key)) return !!obj[key];
  return defaultTrue;
}

/**
 * Migrate pre-slot localStorage booleans → panel slot list (layout grid reset separately).
 * Defaults match RideView: video/graph/map/suspension on, comments off, stats off unless saved.
 * @param {{ showVideo?: boolean, showGraph?: boolean, showMap?: boolean, showComments?: boolean, showStats?: boolean, showSuspension?: boolean }} p
 */
export function migrateLegacyPanelFlagsToSlots(p) {
  const slots = [];
  if (legacyBool(p, 'showVideo', true)) slots.push({ id: newPanelInstanceId(), contentId: 'video' });
  if (legacyBool(p, 'showGraph', true)) slots.push({ id: newPanelInstanceId(), contentId: 'charts' });
  if (legacyBool(p, 'showStats', false)) slots.push({ id: newPanelInstanceId(), contentId: 'stats' });
  if (legacyBool(p, 'showSuspension', true)) slots.push({ id: newPanelInstanceId(), contentId: 'susp-summary' });
  if (legacyBool(p, 'showMap', true)) slots.push({ id: newPanelInstanceId(), contentId: 'map' });
  if (legacyBool(p, 'showComments', false)) slots.push({ id: newPanelInstanceId(), contentId: 'comments' });
  if (slots.length === 0) return getDefaultPanelSlots();
  return slots;
}

/** First-time default: video, charts, suspension summary, map (comments off — matches earlier defaults). */
export function getDefaultPanelSlots() {
  return [
    { id: newPanelInstanceId(), contentId: 'video' },
    { id: newPanelInstanceId(), contentId: 'charts' },
    { id: newPanelInstanceId(), contentId: 'susp-summary' },
    { id: newPanelInstanceId(), contentId: 'map' },
  ];
}

/** @param {Array<{id?: string, contentId?: string}>} raw */
export function normalizePanelSlots(raw) {
  if (!Array.isArray(raw) || raw.length === 0) return null;
  return raw.map((s) => ({
    id: typeof s?.id === 'string' && s.id ? s.id : newPanelInstanceId(),
    contentId: typeof s?.contentId === 'string' && RIDE_PANEL_CATALOG[s.contentId] ? s.contentId : 'charts',
  }));
}

/** For Compare pane / legacy readers that still expect show* booleans. */
export function deriveLegacyPanelFlagsFromSlots(slots) {
  const ids = new Set((slots || []).map((s) => s.contentId));
  return {
    showVideo: ids.has('video'),
    showGraph: ids.has('charts'),
    showMap: ids.has('map'),
    showComments: ids.has('comments'),
    showStats: ids.has('stats'),
    showSuspension: [...ids].some((id) => typeof id === 'string' && id.startsWith('susp-')),
  };
}

/**
 * Read panelSlots from localStorage snapshot; migrate legacy flags once (clears column layout).
 * @param {Record<string, unknown>} parsed rideViewPanelStates object
 */
export function resolvePanelSlotsFromStorage(parsed) {
  const normalized = normalizePanelSlots(parsed?.panelSlots);
  if (normalized) return { slots: normalized, didMigrate: false };

  const migrated = migrateLegacyPanelFlagsToSlots(parsed || {});
  return { slots: migrated, didMigrate: true };
}
